// adding some validations logic for mails form
import { required, email, numeric, alpha, minLength, maxLength } from 'vuelidate/lib/validators'

export const FORM_MAILS_VALIDATIONS = {
  dataForm: {
    mailSmtpHost: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(50)
    },
    mailSmtpAuth: {},
    mailSmtpUsername: {
      required,
      email
    },
    mailSmtpPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(255)
    },
    mailSmtpSecure: {
      required,
      validValue : val => {
        switch (val.toLowerCase()) {
          case '':
            return true;
          case 'ssl':
            return true;
          case 'tls':
            return true;
          case 'starttls':
            return true;
          case ! val.match(/^[A-Za-z]+$/):
            return false;
          default:
            return false
        }
      }
    },
    mailSmtpPort: {
      required,
      numeric,
      minLength: minLength(2),
      maxLength: maxLength(4)
    },
    mailSetFromEmail: {
      required,
      email
    },
    mailSetFromName: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(50)
    },
    mailRecipientEmail: {
      required,
      email
    },
    mailRecipientName: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(50)
    },
    mailReplyToEmail: {
      required,
      email
    },
    mailReplyToName: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(50)
    },
    mailCcEmail: {
      email
    },
    mailCcName: {
      minLength: minLength(5),
      maxLength: maxLength(50)
    },
    mailBccEmail: {
      email
    },
    mailBccName: {
      minLength: minLength(5),
      maxLength: maxLength(50)
    },
    mailAttachments: {},
    mailIsHtml: {},
    mailSubject: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
    mailBody: {
      required,
      minLength: minLength(25)
    },
    mailAltBody: {
      required,
      minLength: minLength(25)
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formMails.js